module.exports = __webpack_public_path__ + "static/media/rocket_launch_.12f741d0.png";